export const MAX_LENGTH_DESCRIPTION = 1000;